export const log = require('debug')('store')
